module.exports = __webpack_public_path__ + "img/logo.7f33a0d4.png";